import { twJoin } from "tailwind-merge";

interface AnalyticsSectionProps {
  id?: string;
  title: string;
  description?: string;
  /** Keeps a single node or fragment in one column at medium widths. Array children use the two-column card grid. */
  isFullWidth?: boolean;
  /** Arrays select the two-column card grid; fragments and other single nodes use the single-node layout. */
  children: React.ReactNode;
}

export function AnalyticsSection({
  id,
  title,
  description,
  isFullWidth,
  children,
}: AnalyticsSectionProps): React.ReactNode {
  return (
    <section className="flex size-full flex-col items-start gap-space-md">
      <header className="flex w-full flex-col gap-space-sm">
        <h2 id={id} className="text-heading-2 text-text-brand-secondary">
          {title}
        </h2>
        {description && <span className="text-caption text-text-secondary">{description}</span>}
      </header>
      <div
        className={twJoin(
          "grid w-full grid-cols-1 items-start gap-space-lg",
          Array.isArray(children) && "@md:grid-cols-2",
          !Array.isArray(children) && isFullWidth && "@md:grid-cols-1",
          !Array.isArray(children) && !isFullWidth && "@lg:grid-cols-1 @xl:grid-cols-2",
        )}
      >
        {children}
      </div>
    </section>
  );
}
